/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SnLetterAvatarComponent } from './letter-avatar.component';
var SnLetterAvatarModule = /** @class */ (function () {
    function SnLetterAvatarModule() {
    }
    /**
     * @return {?}
     */
    SnLetterAvatarModule.forRoot = /**
     * @return {?}
     */
    function () {
        return {
            ngModule: SnLetterAvatarModule
        };
    };
    SnLetterAvatarModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        SnLetterAvatarComponent
                    ],
                    exports: [
                        SnLetterAvatarComponent
                    ]
                },] }
    ];
    return SnLetterAvatarModule;
}());
export { SnLetterAvatarModule };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGV0dGVyLWF2YXRhci5tb2R1bGUuanMiLCJzb3VyY2VSb290Ijoibmc6Ly9AaW5zaWdodC9zZXJlbml0eS1uZ3gvIiwic291cmNlcyI6WyJsaWIvbGV0dGVyLWF2YXRhci9sZXR0ZXItYXZhdGFyLm1vZHVsZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7O0FBQUEsT0FBTyxFQUFFLFFBQVEsRUFBdUIsTUFBTSxlQUFlLENBQUM7QUFDOUQsT0FBTyxFQUFFLFlBQVksRUFBRSxNQUFNLGlCQUFpQixDQUFDO0FBRS9DLE9BQU8sRUFBRSx1QkFBdUIsRUFBRSxNQUFNLDJCQUEyQixDQUFDO0FBRXBFO0lBQUE7SUFpQkEsQ0FBQzs7OztJQUxpQiw0QkFBTzs7O0lBQXJCO1FBQ0ksT0FBTztZQUNILFFBQVEsRUFBRSxvQkFBb0I7U0FDakMsQ0FBQztJQUNOLENBQUM7O2dCQWhCSixRQUFRLFNBQUM7b0JBQ04sT0FBTyxFQUFFO3dCQUNMLFlBQVk7cUJBQ2Y7b0JBQ0QsWUFBWSxFQUFFO3dCQUNWLHVCQUF1QjtxQkFDMUI7b0JBQ0QsT0FBTyxFQUFFO3dCQUNMLHVCQUF1QjtxQkFDMUI7aUJBQ0o7O0lBT0QsMkJBQUM7Q0FBQSxBQWpCRCxJQWlCQztTQU5ZLG9CQUFvQiIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IE5nTW9kdWxlLCBNb2R1bGVXaXRoUHJvdmlkZXJzIH0gZnJvbSAnQGFuZ3VsYXIvY29yZSc7XG5pbXBvcnQgeyBDb21tb25Nb2R1bGUgfSBmcm9tICdAYW5ndWxhci9jb21tb24nO1xuXG5pbXBvcnQgeyBTbkxldHRlckF2YXRhckNvbXBvbmVudCB9IGZyb20gJy4vbGV0dGVyLWF2YXRhci5jb21wb25lbnQnO1xuXG5ATmdNb2R1bGUoe1xuICAgIGltcG9ydHM6IFtcbiAgICAgICAgQ29tbW9uTW9kdWxlXG4gICAgXSxcbiAgICBkZWNsYXJhdGlvbnM6IFtcbiAgICAgICAgU25MZXR0ZXJBdmF0YXJDb21wb25lbnRcbiAgICBdLFxuICAgIGV4cG9ydHM6IFtcbiAgICAgICAgU25MZXR0ZXJBdmF0YXJDb21wb25lbnRcbiAgICBdXG59KVxuZXhwb3J0IGNsYXNzIFNuTGV0dGVyQXZhdGFyTW9kdWxlIHtcbiAgICBwdWJsaWMgc3RhdGljIGZvclJvb3QoKTogTW9kdWxlV2l0aFByb3ZpZGVycyB7XG4gICAgICAgIHJldHVybiB7XG4gICAgICAgICAgICBuZ01vZHVsZTogU25MZXR0ZXJBdmF0YXJNb2R1bGVcbiAgICAgICAgfTtcbiAgICB9XG59XG4iXX0=